import UpdateRequestTravel from '@/requests/travels/user/updateRequestTravel'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/_authenticated/requests/$id/travels/$travelId/updateTravel',
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <UpdateRequestTravel />
    )
}